import {
  isFlagEnabled,
  isToggleEnabled,
  hasAbility,
  currentUserRole,
  isCurrentUserRestricted,
  isCurrentUserAccountTrial,
  isCurrentUserAccountStandard,
  isCurrentUserAccountEnterprise,
  currentUserData,
  isCurrentUserAnAccountOwner,
  isCurrentUserAnAdmin
} from '../../features/fe-data/selectors';

export const allowForEveryone = () => true;

export const allowAlerts = state => isFlagEnabled(state)('beta_alerts_list') || hasAbility(state)('using_alerts_on_any_service');

export const allowApiAccess = state => ['owner', 'admin'].includes(currentUserRole(state));

export const allowAppDirectory = state => ['owner', 'admin', 'user'].includes(currentUserRole(state));

export const allowDeveloperMode = state => ['owner', 'admin', 'user'].includes(currentUserRole(state));

export const allowResponsePlays = state => hasAbility(state)('response_automation');

export const allowVisibility = (state) => {
  const hasLite = isFlagEnabled(state)('visibility_console_lite');
  const hasStandard = isFlagEnabled(state)('visibility_console');

  if (hasLite && !hasStandard) {
    // Remove this conditional, once VIS-Console Lite is rolled out to 100%.
    return isToggleEnabled(state)('visibility_console_lite');
  }

  return hasAbility(state)('business_visibility');
};

export const allowChangeEvents = state => isToggleEnabled(state)('change_events');

export const allowImpactMetrics = state => hasAbility(state)('business_visibility');

export const allowSchedules = state => hasAbility(state)('manage_schedules');

export const allowServiceDirectory = state => (
  !isToggleEnabled(state)('service_directory_ui_blacklist')
    && (isToggleEnabled(state)('service_directory_ui_rollout')
    || isToggleEnabled(state)('service_directory_ui'))
);

export const allowEventRules = state => (
  (hasAbility(state)('event_rules')
    && (['owner', 'admin'].includes(currentUserRole(state))
    || isFlagEnabled(state)('global_event_rules_all_users')))
    || hasAbility(state)('global_rulesets')
);

export const allowEventIntelligence = state => isFlagEnabled(state)('event_intelligence_landing_page');

export const allowStatusPage = state => !isToggleEnabled(state)('bis_impact') && (isFlagEnabled(state)('status_dashboard') || isFlagEnabled(state)('status_dashboard_advanced'));
export const allowBISStatusPage = state => isToggleEnabled(state)('bis_impact');

export const allowPdLabs = state => (
  !isCurrentUserRestricted(state)
    && (
      (isToggleEnabled(state)('pd_labs_nav'))
      || (isFlagEnabled(state)('analytics_sku'))
      || ((isFlagEnabled(state)('preview_intelligent_alert_grouping')) && (isFlagEnabled(state)('paused_incident_notification')))
    )
);

export const allowAnalyticsDashboards = state => (
  !isCurrentUserRestricted(state)
    && (isFlagEnabled(state)('analytics_sku')
    || isFlagEnabled(state)('analytics_dashboards'))
);

export const allowReports = state => !isCurrentUserRestricted(state) || isFlagEnabled(state)('advanced_reports_for_restricted_users');

export const allowReportsPreview = state => !isCurrentUserRestricted(state) && !hasAbility(state)('advanced_reports');

export const allowAdvancedReports = state => (
  (!isCurrentUserRestricted(state)
    || isFlagEnabled(state)('advanced_reports_for_restricted_users'))
    && hasAbility(state)('advanced_reports')
);

export const allowPostmortems = state => (
  isFlagEnabled(state)('post_mortem')
    || isCurrentUserAccountTrial(state)
    || isCurrentUserAccountStandard(state)
    || isCurrentUserAccountEnterprise(state)
    || isFlagEnabled(state)('test_mode')
    || isFlagEnabled(state)('trial_modern_incident_response_sku')
);

export const allowExtensions = state => !isCurrentUserRestricted(state);

export const allowConferenceBridges = state => !isCurrentUserRestricted(state);

export const allowAddOns = state => !isCurrentUserRestricted(state);

export const allowOperationalReviews = state => (
  !isCurrentUserRestricted(state)
    && (isFlagEnabled(state)('analytics_sku')
    || isToggleEnabled(state)('show_operational_reviews_user')
    || isToggleEnabled(state)('show_operational_reviews_subdomain'))
);

export const allowGlobalSearch = state => isToggleEnabled(state)('global_search');

export const allowTeams = state => hasAbility(state)('teams');

export const allowOperationsHealth = state => isFlagEnabled(state)('operations_health');

export const allowAccountSettings = state => ['owner', 'admin'].includes(currentUserRole(state));

export const allowOwnerAccountSettings = state => isCurrentUserAnAccountOwner(state);
export const allowAdminAccountSettings = state => isCurrentUserAnAdmin(state);


export const allowAdminDashboard = state => (
  ['owner', 'admin'].includes(currentUserRole(state))
    && isToggleEnabled(state)('admin_dashboard_navigation_enable')
);

export const allowOnCallReadiness = state => isFlagEnabled(state)('responder_readiness');

export const allowServiceIntelligence = state => currentUserData(state).canSeeServiceIntelligence;
